import { useRef, useEffect, useContext, useState, useMemo } from "react";
import { TextEditorContext } from "../../../context/TextEditorContext";
import { EmailTemplateContext } from "../../../context/EmailTemplateContext";
import { SelectedElementContex } from "../../../context/SelectedElement";
import { DatabaseDropdownContext } from "../../../context/DatabaseDropdownContext";
import { TableRowColumnIndexContex } from "../../../context/TableRowColumnIndexContex";

// import ReactQuill, { Quill } from "react-quill";
// import ImageResize from "quill-image-resize-module-react";
// import juice from "juice";
// import "react-quill/dist/quill.snow.css";
import axios from "axios";
import api from "../../../services/api";
import { BASE_URL } from "../../../services/configUrls";
import { Trash, Replace, Trash2 } from "lucide-react";

// ============= PROPER SIZE FORMAT REGISTRATION =============
// const Size = Quill.import("formats/size");
// Size.whitelist = ["12px", "14px", "16px", "18px", "24px", "32px", "48px"];
// Quill.register(Size, true);

// // Register the image resize module
// Quill.register("modules/imageResize", ImageResize);

// // Custom inline image format
// const ImageBlot = Quill.import("formats/image");
// class InlineImageBlot extends ImageBlot {
//   static create(value) {
//     const node = super.create(value);
//     node.setAttribute(
//       "style",
//       "display: inline-block; vertical-align: middle; max-width: 100%;"
//     );
//     return node;
//   }
// }
// InlineImageBlot.blotName = "image";
// InlineImageBlot.tagName = "IMG";
// Quill.register(InlineImageBlot, true);

export default function TextComponent({ id, style, textarea }) {
  const { selectedElement, setSelectedElement, editDiv, setEditDiv } =
    useContext(SelectedElementContex);
  const {
    isTextSelected,
    setIsTextSelected,
    registerApplyStyle,
    registerSaveHandler,
    registerInsertImage,
    registerGetStyles,
  } = useContext(TextEditorContext);
  const { setEmailTemplate } = useContext(EmailTemplateContext);
  const { showCursor, isDragging, setShowCursor, setIsDragging } = useContext(
    DatabaseDropdownContext
  );
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const { savedRangeRef } = useContext(TableRowColumnIndexContex);
  const textRef = useRef(null);
  const linkInputRef = useRef(null);

  const lastRangeRef = useRef(null);

  const [content, setContent] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [uploading, setUploading] = useState(false);
  const quillRef = useRef(null);
  const fileInputRef = useRef(null);

  const [selectedImage, setSelectedImage] = useState(null);
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });

  const currentImageRef = useRef(null);
  const resizingRef = useRef(false);
  const editorContainerRef = useRef(null);

  const [appliedStyles, setAppliedStyles] = useState({});

  // Create resize handles
  // const createResizeHandles = (img) => {
  //   removeResizeHandles();
  //   currentImageRef.current = img;

  //   const imgHeight = img.offsetHeight;
  //   const imgWidth = img.offsetWidth;
  //   const imgRect = img.getBoundingClientRect();
  //   const editorRect = textRef.current.getBoundingClientRect();

  //   const top = imgRect.top - editorRect.top + textRef.current.scrollTop - 1;
  //   const left = imgRect.left - editorRect.left + textRef.current.scrollLeft - 1;

  //   // Create resize frame (bottom-right handle)
  //   const resizeFrame = document.createElement('span');
  //   resizeFrame.className = 'resize-frame';
  //   Object.assign(resizeFrame.style, {
  //     position: 'absolute',
  //     top: `${top + imgHeight - 10}px`,
  //     left: `${left + imgWidth - 10}px`,
  //     border: 'solid 3px #2196F3',
  //     width: '6px',
  //     height: '6px',
  //     cursor: 'nwse-resize',
  //     zIndex: '1000',
  //     backgroundColor: 'white'
  //   });

  //   resizeFrame.onmousedown = (e) => {
  //     e.preventDefault();
  //     e.stopPropagation();
  //     resizingRef.current = true;
  //     return false;
  //   };

  //   // Create border indicators
  //   const topBorder = createBorder('top-border', top, left, imgWidth, 0);
  //   const leftBorder = createBorder('left-border', top, left, 0, imgHeight);
  //   const rightBorder = createBorder('right-border', top, left + imgWidth, 0, imgHeight);
  //   const bottomBorder = createBorder('bottom-border', top + imgHeight, left, imgWidth, 0);

  //   textRef.current.appendChild(resizeFrame);
  //   textRef.current.appendChild(topBorder);
  //   textRef.current.appendChild(leftBorder);
  //   textRef.current.appendChild(rightBorder);
  //   textRef.current.appendChild(bottomBorder);
  // };

  // Create resize handles with delete button
  const createResizeHandles = (img) => {
    removeResizeHandles();
    currentImageRef.current = img;

    const imgHeight = img.offsetHeight;
    const imgWidth = img.offsetWidth;
    const imgRect = img.getBoundingClientRect();
    const editorRect = textRef.current.getBoundingClientRect();

    const top = imgRect.top - editorRect.top + textRef.current.scrollTop - 1;
    const left =
      imgRect.left - editorRect.left + textRef.current.scrollLeft - 1;

    // Create delete button (cross icon) - top right corner
    const deleteBtn = document.createElement("span");
    deleteBtn.className = "delete-btn";
    deleteBtn.innerHTML = "×"; // Cross symbol
    Object.assign(deleteBtn.style, {
      position: "absolute",
      top: `${top - 12}px`,
      left: `${left + imgWidth - 8}px`,
      width: "20px",
      height: "20px",
      backgroundColor: "#f44336",
      color: "white",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      fontSize: "18px",
      fontWeight: "bold",
      zIndex: "1001",
      border: "2px solid white",
      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    });

    deleteBtn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      handleDeleteImage(img);
    };

    // Create resize frame (bottom-right handle)
    const resizeFrame = document.createElement("span");
    resizeFrame.className = "resize-frame";
    Object.assign(resizeFrame.style, {
      position: "absolute",
      top: `${top + imgHeight - 10}px`,
      left: `${left + imgWidth - 10}px`,
      border: "solid 3px #2196F3",
      width: "6px",
      height: "6px",
      cursor: "nwse-resize",
      zIndex: "1000",
      backgroundColor: "white",
    });

    resizeFrame.onmousedown = (e) => {
      e.preventDefault();
      e.stopPropagation();
      resizingRef.current = true;
      return false;
    };

    // Create border indicators
    const topBorder = createBorder("top-border", top, left, imgWidth, 0);
    const leftBorder = createBorder("left-border", top, left, 0, imgHeight);
    const rightBorder = createBorder(
      "right-border",
      top,
      left + imgWidth,
      0,
      imgHeight
    );
    const bottomBorder = createBorder(
      "bottom-border",
      top + imgHeight,
      left,
      imgWidth,
      0
    );

    textRef.current.appendChild(deleteBtn);
    textRef.current.appendChild(resizeFrame);
    textRef.current.appendChild(topBorder);
    textRef.current.appendChild(leftBorder);
    textRef.current.appendChild(rightBorder);
    textRef.current.appendChild(bottomBorder);
  };

  const createBorder = (className, top, left, width, height) => {
    const border = document.createElement("span");
    border.className = `resizer ${className}`;
    Object.assign(border.style, {
      position: "absolute",
      top: `${top}px`,
      left: `${left}px`,
      border: "dashed 1px #2196F3",
      width: `${width}px`,
      height: `${height}px`,
      pointerEvents: "none",
    });
    return border;
  };

  const removeResizeHandles = () => {
    const handles = textRef.current.querySelectorAll(
      ".resize-frame, .resizer, .delete-btn"
    );
    handles.forEach((handle) => handle.remove());
  };

  // Delete image handler
  const handleDeleteImage = (img) => {
    if (img && img.parentNode) {
      img.remove();
      removeResizeHandles();
      currentImageRef.current = null;
      saveTextarea(); // Save after deletion
    }
  };

  const handleImageClick = (e) => {
    if (e.target.tagName === "IMG") {
      e.preventDefault();
      createResizeHandles(e.target);
    } else if (
      !e.target.classList.contains("resize-frame") &&
      !e.target.classList.contains("delete-btn")
    ) {
      removeResizeHandles();
      currentImageRef.current = null;
    }
  };

  // Helper to convert rgb to hex
  const rgbToHex = (rgb) => {
    if (!rgb || rgb === "rgba(0, 0, 0, 0)" || rgb === "transparent")
      return "transparent";
    const match = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    if (!match) return rgb;

    const hex = (x) => ("0" + parseInt(x).toString(16)).slice(-2);
    return "#" + hex(match[1]) + hex(match[2]) + hex(match[3]);
  };

  const getAppliedStyles = () => {
    const selection = window.getSelection();
    if (!selection.rangeCount) return {};

    const range = selection.getRangeAt(0);
    const container = range.commonAncestorContainer;

    // Get the element (not text node)
    const element =
      container.nodeType === 3 ? container.parentElement : container;

    if (!element || !textRef.current?.contains(element)) return {};

    const styles = window.getComputedStyle(element);

    return {
      fontWeight:
        styles.fontWeight === "bold" || parseInt(styles.fontWeight) >= 700
          ? "bold"
          : "normal",
      fontStyle: styles.fontStyle,
      textDecoration: styles.textDecoration,
      backgroundColor: rgbToHex(styles.backgroundColor),
    };
  };

  // const handleMouseMove = (e) => {
  //   if (!currentImageRef.current || !resizingRef.current) return;

  //   const img = currentImageRef.current;
  //   const imgRect = img.getBoundingClientRect();
  //   const editorRect = textRef.current.getBoundingClientRect();

  //   const imgTop = imgRect.top - editorRect.top + textRef.current.scrollTop;
  //   const imgLeft = imgRect.left - editorRect.left + textRef.current.scrollLeft;

  //   let newHeight = e.pageY - (editorRect.top + window.scrollY) - imgTop + textRef.current.scrollTop;
  //   let newWidth = e.pageX - (editorRect.left + window.scrollX) - imgLeft + textRef.current.scrollLeft;

  //   newHeight = Math.max(20, newHeight);
  //   newWidth = Math.max(20, newWidth);

  //   img.style.width = `${newWidth}px`;
  //   img.style.height = `${newWidth}px`;

  //   // Update handles position
  //   createResizeHandles(img);
  // };

  const handleMouseMove = (e) => {
    if (!currentImageRef.current || !resizingRef.current) return;

    const img = currentImageRef.current;
    const imgRect = img.getBoundingClientRect();
    const editorRect = textRef.current.getBoundingClientRect();

    const imgTop = imgRect.top - editorRect.top + textRef.current.scrollTop;
    const imgLeft = imgRect.left - editorRect.left + textRef.current.scrollLeft;

    // Calculate the aspect ratio from the original/current image
    const aspectRatio = img.naturalWidth / img.naturalHeight;

    let newWidth =
      e.pageX -
      (editorRect.left + window.scrollX) -
      imgLeft +
      textRef.current.scrollLeft;

    // Ensure minimum size
    newWidth = Math.max(20, newWidth);

    // Calculate height based on aspect ratio (unless Shift key is pressed)
    let newHeight;
    if (e.shiftKey) {
      newHeight =
        e.pageY -
        (editorRect.top + window.scrollY) -
        imgTop +
        textRef.current.scrollTop;
      newHeight = Math.max(20, newHeight);
    } else {
      newHeight = newWidth / aspectRatio;
    }

    img.style.width = `${newWidth}px`;
    img.style.height = `${newHeight}px`;

    // Update handles position
    createResizeHandles(img);
  };

  const handleMouseUp = () => {
    if (resizingRef.current) {
      resizingRef.current = false;
      if (currentImageRef.current) {
        createResizeHandles(currentImageRef.current);
      }
    }
  };

  // Handle image upload to FastAPI
  // const handleImageUpload = async (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   setUploading(true);
  //   const formData = new FormData();
  //   formData.append("file", file);

  //   try {
  //     const res = await axios.post(
  //       `${BASE_URL}/schedule_email/upload-image`,
  //       formData,
  //       {
  //         headers: { "Content-Type": "multipart/form-data" },
  //       }
  //     );

  //     const url = res.data.image_url;
  //     setImageUrl(url);
  //     setUploading(false);
  //   } catch (error) {
  //     console.error("Upload failed:", error);
  //     alert("Image upload failed");
  //     setUploading(false);
  //   }
  // };

  // const insertImage = () => {
  //   if (!imageUrl.trim()) {
  //     alert("Please enter an image URL or upload an image");
  //     return;
  //   }

  //   const quill = quillRef.current.getEditor();

  //   // Focus editor first
  //   quill.focus();

  //   // Use setTimeout to ensure focus is applied
  //   setTimeout(() => {
  //     if (selectedImage) {
  //       // Find image blot and replace
  //       const imgBlot = quill.constructor.find(selectedImage);
  //       if (imgBlot) {
  //         const imageIndex = quill.getIndex(imgBlot);
  //         quill.deleteText(imageIndex, 1);
  //         quill.insertEmbed(imageIndex, "image", imageUrl, "user");
  //         quill.setSelection(imageIndex + 1);
  //       }
  //       setSelectedImage(null);
  //     } else {
  //       // Insert new image
  //       const range = quill.getSelection(true) || {
  //         index: quill.getLength() > 0 ? quill.getLength() - 1 : 0,
  //       };

  //       quill.insertEmbed(range.index, "image", imageUrl, "user");
  //       quill.setSelection(range.index + 1);
  //     }

  //     // Save changes
  //     saveTextarea(quill.root.innerHTML);
  //   }, 50);

  //   setImageUrl("");
  //   setShowImageModal(false);
  // };

  // // Custom image handler for toolbar
  // const imageHandler = () => {
  //   setShowImageModal(true);
  // };

  // const modules = useMemo(
  //   () => ({
  //     toolbar: {
  //       container: [
  //         [{ header: [1, 2, 3, 4, 5, 6, false] }],
  //         [{ size: ["12px", "14px", "16px", "18px", "24px", "32px", "48px"] }],
  //         ["bold", "italic", "underline", "strike"],
  //         [{ color: [] }, { background: [] }],
  //         [{ align: [] }],
  //         [{ list: "ordered" }, { list: "bullet" }],
  //         ["link", "image"],
  //         ["clean"],
  //       ],
  //       handlers: {
  //         image: imageHandler,
  //       },
  //     },
  //     imageResize: {
  //       parchment: Quill.import("parchment"),
  //       modules: ["Resize", "DisplaySize"],
  //     },
  //   }),
  //   []
  // );

  // const formats = [
  //   "header",
  //   "size",
  //   "bold",
  //   "italic",
  //   "underline",
  //   "strike",
  //   "color",
  //   "background",
  //   "align",
  //   "list",
  //   "bullet",
  //   "link",
  //   "image",
  //   "width",
  //   "height",
  // ];

  // Convert to Gmail-safe inline CSS
  // const convertToInlineCSS = (htmlContent) => {
  //   // Create a temporary DOM element to parse the HTML
  //   const tempDiv = document.createElement("div");
  //   tempDiv.innerHTML = htmlContent;

  //   // Convert font size classes to inline styles
  //   const sizeClasses = [
  //     "12px",
  //     "14px",
  //     "16px",
  //     "18px",
  //     "24px",
  //     "32px",
  //     "48px",
  //   ];
  //   sizeClasses.forEach((size) => {
  //     const elements = tempDiv.querySelectorAll(`.ql-size-${size}`);
  //     elements.forEach((el) => {
  //       el.style.fontSize = size;
  //       el.classList.remove(`ql-size-${size}`);
  //     });
  //   });

  //   // Convert alignment classes to inline styles
  //   const alignments = ["left", "center", "right", "justify"];
  //   alignments.forEach((align) => {
  //     const elements = tempDiv.querySelectorAll(`.ql-align-${align}`);
  //     elements.forEach((el) => {
  //       el.style.textAlign = align;
  //       el.classList.remove(`ql-align-${align}`);
  //     });
  //   });

  //   // Clean up any remaining Quill classes
  //   const allElements = tempDiv.querySelectorAll("[class]");
  //   allElements.forEach((el) => {
  //     const classes = Array.from(el.classList);
  //     classes.forEach((className) => {
  //       if (className.startsWith("ql-")) {
  //         el.classList.remove(className);
  //       }
  //     });
  //     // Remove empty class attributes
  //     if (el.classList.length === 0) {
  //       el.removeAttribute("class");
  //     }
  //   });

  //   // Remove cursor styles from images
  //   const images = tempDiv.querySelectorAll("img");
  //   images.forEach((img) => {
  //     const style = img.getAttribute("style") || "";
  //     const cleanedStyle = style.replace(/cursor:\s*[^;]+;?/gi, "").trim();
  //     if (cleanedStyle) {
  //       img.setAttribute("style", cleanedStyle);
  //     }
  //   });

  //   const processedHTML = tempDiv.innerHTML;
  //   // const emailHTML = `
  //   //   <!DOCTYPE html>
  //   //   <html>
  //   //   <head>
  //   //     <style>
  //   //       p { margin: 0 0 10px 0; line-height: 1.5; }
  //   //       strong { font-weight: bold; }
  //   //       em { font-style: italic; }
  //   //       u { text-decoration: underline; }
  //   //       img { display: inline-block; vertical-align: middle; max-width: 100%; }
  //   //     </style>
  //   //   </head>
  //   //   <body>${processedHTML}</body>
  //   //   </html>
  //   // `;

  //   return juice(processedHTML);
  // };

  // const handleSave = async () => {
  //   const gmailSafeHTML = convertToInlineCSS(content);
  //   console.log("Gmail-ready HTML:", gmailSafeHTML);

  //   const response = await api.post(
  //     "/schedule_email/send-email",
  //     {
  //       to: "mpapu177@gmail.com",
  //       subject: "Your Email Template",
  //       htmlTemplate: gmailSafeHTML,
  //       attachments: null,
  //     },
  //     {
  //       headers: { "Content-Type": "application/json" },
  //     }
  //   );

  //   const res = await response.data;
  //   console.log(res.data);
  // };

  // Setup tooltips and image click handlers
  // useEffect(() => {
  //   const toolbar = document.querySelector(".ql-toolbar");

  //   if (toolbar) {
  //     const tooltips = {
  //       ".ql-header": "Heading",
  //       ".ql-size": "Font size",
  //       ".ql-bold": "Bold",
  //       ".ql-italic": "Italic",
  //       ".ql-underline": "Underline",
  //       ".ql-strike": "Strikethrough",
  //       ".ql-color": "Text color",
  //       ".ql-background": "Highlight",
  //       ".ql-align": "Alignment",
  //       ".ql-list.ql-bullet": "Bullet list",
  //       ".ql-list.ql-ordered": "Numbered list",
  //       ".ql-link": "Insert link",
  //       ".ql-image": "Insert image",
  //       ".ql-clean": "Clear formatting",
  //     };

  //     Object.entries(tooltips).forEach(([selector, title]) => {
  //       const btn = toolbar.querySelector(selector);
  //       if (btn) btn.setAttribute("title", title);
  //     });
  //   }

  // Handle image clicks for delete/replace functionality
  // const handleImageClick = (e) => {
  //   if (e.target.tagName === "IMG") {
  //     setSelectedImage(e.target);
  //     const rect = e.target.getBoundingClientRect();
  //     setTooltipPos({
  //       top: rect.bottom + window.scrollY + 5,
  //       left: rect.left + window.scrollX,
  //     });
  //   } else {
  //     setSelectedImage(null);
  //   }
  // };

  //   const editor = document.querySelector(".ql-editor");
  //   if (editor) {
  //     editor.addEventListener("click", handleImageClick);
  //   }

  //   return () => {
  //     if (editor) {
  //       editor.removeEventListener("click", handleImageClick);
  //     }
  //   };
  // }, []);

  // const wrapWithResizer = (img) => {
  //   const wrapper = document.createElement("span");
  //   wrapper.style.position = "relative";
  //   wrapper.style.display = "inline-flex"; // <— FIXED
  //   wrapper.style.alignItems = "flex-end"; // <— FIXED

  //   const handle = document.createElement("span");
  //   handle.style.width = "10px";
  //   handle.style.height = "10px";
  //   handle.style.background = "#333";
  //   handle.style.position = "absolute";
  //   handle.style.right = "0";
  //   handle.style.bottom = "0";
  //   handle.style.cursor = "nwse-resize";
  //   handle.style.borderRadius = "2px";

  //   img.style.display = "block"; // <— FIXED to allow height growth

  //   wrapper.appendChild(img);
  //   wrapper.appendChild(handle);

  //   let startX, startY, startWidth, startHeight;

  //   handle.onmousedown = (e) => {
  //     e.preventDefault();

  //     startX = e.clientX;
  //     startY = e.clientY;
  //     startWidth = img.clientWidth;
  //     startHeight = img.clientHeight;

  //     document.onmousemove = (e2) => {
  //       const diffX = e2.clientX - startX;
  //       const diffY = e2.clientY - startY;

  //       // Prevent negative sizes
  //       const newWidth = Math.max(20, startWidth + diffX);
  //       const newHeight = Math.max(20, startHeight + diffY);

  //       img.style.width = newWidth + "px";
  //       img.style.height = newHeight + "px";
  //     };

  //     document.onmouseup = () => {
  //       document.onmousemove = null;
  //       document.onmouseup = null;
  //     };
  //   };

  //   return wrapper;
  // };

  const saveSelection = () => {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      lastRangeRef.current = selection.getRangeAt(0);

      const text = selection.toString().trim();

      // tell context whether text is selected
      if (text.length > 0) {
        setIsTextSelected(true);
      } else {
        setIsTextSelected(false);
      }
    } else {
      lastRangeRef.current = selection;
    }
  };

  const saveSelectionforAcnchor = () => {
    const sel = window.getSelection();
    if (sel.rangeCount > 0) {
      savedRangeRef.current = sel.getRangeAt(0).cloneRange();
    }
  };

  const applyStyleToSelectedText = (styleObj) => {
    const selection = window.getSelection();
    let range;

    if (selection.rangeCount > 0) {
      range = selection.getRangeAt(0);
    } else if (lastRangeRef.current) {
      range = lastRangeRef.current;
      selection.removeAllRanges();
      selection.addRange(range);
    } else {
      return;
    }

    const styleKey = Object.keys(styleObj)[0];
    const styleValue = styleObj[styleKey];

    const container = range.commonAncestorContainer;
    let element =
      container.nodeType === 3 ? container.parentElement : container;

    // ✅ Find if the selection is within a span that has this style
    let targetSpan = null;
    let checkElement = element;

    while (checkElement && checkElement !== textRef.current) {
      if (checkElement.tagName === "SPAN") {
        const currentValue = checkElement.style[styleKey];
        let hasStyle = false;

        if (
          styleKey === "fontWeight" &&
          (currentValue === "bold" || parseInt(currentValue) >= 700)
        ) {
          hasStyle = true;
        } else if (styleKey === "fontStyle" && currentValue === styleValue) {
          hasStyle = true;
        } else if (
          styleKey === "textDecoration" &&
          currentValue &&
          currentValue.includes(styleValue)
        ) {
          hasStyle = true;
        } else if (
          styleKey === "backgroundColor" &&
          currentValue &&
          rgbToHex(currentValue) === styleValue
        ) {
          hasStyle = true;
        }

        if (hasStyle) {
          targetSpan = checkElement;
          break;
        }
      }
      checkElement = checkElement.parentElement;
    }

    if (targetSpan) {

      if (styleKey === "textDecoration") {
        // ✅ FIX: Handle text-decoration properly
        const currentDeco = targetSpan.style.textDecoration;

        // Split by space and filter out the value we want to remove
        const decoValues = currentDeco
          .split(" ")
          .map((v) => v.trim())
          .filter(
            (v) => v && v !== styleValue && v !== styleValue.replace(/-/g, "")
          );


        if (decoValues.length > 0) {
          targetSpan.style.textDecoration = decoValues.join(" ");
        } else {
          // ✅ No decoration values remain, remove completely
          targetSpan.style.textDecoration = "none";
          targetSpan.style.removeProperty("text-decoration");
        }
      } else {
        // For other styles
        targetSpan.style[styleKey] = "";
        targetSpan.style.removeProperty(styleKey);
      }

      // ✅ Check if any meaningful styles remain
      const remainingStyles = targetSpan.style.cssText
        .replace(/text-decoration:\s*none;?/gi, "")
        .replace(/\s/g, "")
        .trim();

      if (!remainingStyles || remainingStyles === "") {

        const parent = targetSpan.parentNode;
        const textContent = targetSpan.textContent;
        const textNode = document.createTextNode(textContent);

        parent.replaceChild(textNode, targetSpan);
        parent.normalize();

        setTimeout(() => {
          const newRange = document.createRange();
          try {
            newRange.setStart(textNode, 0);
            newRange.collapse(true);
            selection.removeAllRanges();
            selection.addRange(newRange);
            lastRangeRef.current = newRange;
          } catch (e) {
            console.error("Error restoring selection:", e);
          }
        }, 0);
      } else {

        setTimeout(() => {
          const newRange = document.createRange();
          newRange.selectNodeContents(targetSpan);
          newRange.collapse(false);
          selection.removeAllRanges();
          selection.addRange(newRange);
          lastRangeRef.current = newRange;
        }, 0);
      }

      setTimeout(() => {
        saveTextarea();
      }, 10);
    } else {
      // ✅ APPLY: Add style

      if (element.tagName === "SPAN" && element !== textRef.current) {
        element.style[styleKey] = styleValue;

        setTimeout(() => {
          const newRange = document.createRange();
          newRange.selectNodeContents(element);
          newRange.collapse(false);
          selection.removeAllRanges();
          selection.addRange(newRange);
          lastRangeRef.current = newRange;
        }, 0);
      } else {
        const extracted = range.extractContents();
        const span = document.createElement("span");

        Object.keys(styleObj).forEach((key) => {
          span.style[key] = styleObj[key];
        });

        span.appendChild(extracted);
        range.insertNode(span);

        const newRange = document.createRange();
        newRange.setStartAfter(span);
        newRange.collapse(true);
        selection.removeAllRanges();
        selection.addRange(newRange);
        lastRangeRef.current = newRange;
      }
    }

    // ✅ Save after a short delay to ensure DOM has updated
    setTimeout(() => {
      saveTextarea();
    }, 10);
  };

  const onHandleInputChange1 = (f_name, value) => {
    // ✅ Add null check
    if (
      !selectedElement ||
      !selectedElement.layout ||
      !selectedElement.layout[selectedElement.index]
    ) {
      console.warn("selectedElement is not ready");
      return;
    }
    //  Copy current selectedElement
    const updatedData = { ...selectedElement };
    // Updated the specific field
    updatedData.layout[selectedElement.index][f_name] = value;
    // Update original selectedElement
    setSelectedElement(updatedData);
  };

  const removeEmptySpans = () => {
    if (!textRef.current) return; // Guard clause

    const spans = textRef.current.querySelectorAll("span");
    spans.forEach((sp) => {
      if (!sp.innerHTML.trim()) sp.remove();
    });
  };

  // Save edited HTML into emailTemplate array
  const saveTextarea = () => {
    if (!textRef.current) return; 

    // Remove empty wrappers & weird tags
    removeEmptySpans();
    removeResizeHandles();

    let html = textRef.current.innerHTML;

    // Fix empty case
    if (html === "<br>" || html.trim() === "") {
      html = "";
      if (textRef.current) {
        // Additional check before setting
        textRef.current.innerHTML = "";
      }
    }
    onHandleInputChange1("textarea", html);
  };

  // const saveTextarea = (newValue) => {
  // Remove empty wrappers & weird tags
  // removeEmptySpans();

  // let html = textRef.current.innerHTML;

  // // Fix empty case
  // if (html === "<br>" || html.trim() === "") {
  //   html = "";
  //   textRef.current.innerHTML = "";
  // }
  // const gmailSafeHTML = convertToInlineCSS(newValue);
  // console.log("Gmail-ready HTML:", gmailSafeHTML);
  //   onHandleInputChange1("textarea", newValue);
  // };

  const insertImageAtCursor = (url) => {
    const selection = window.getSelection();
    let range = lastRangeRef.current;

    if (!range) {
      range = document.createRange();
      range.selectNodeContents(textRef.current);
      range.collapse(false);
    }

    selection.removeAllRanges();
    selection.addRange(range);

    const img = document.createElement("img");
    img.src = url;
    img.alt = "img";
    img.style.display = "inline";
    // img.style.width = "300px";
    img.style.verticalAlign = "middle";
    img.contentEditable = "false";

    range.insertNode(img);

    range.setStartAfter(img);
    range.collapse(true);
    selection.removeAllRanges();
    selection.addRange(range);

    lastRangeRef.current = range;
  };

  // const insertImageAtCursor = (url) => {
  //   const selection = window.getSelection();
  //   let range = lastRangeRef.current; // saved cursor from onMouseUp/onKeyUp

  //   // If no saved range or cursor lost → insert at end
  //   if (!range) {
  //     range = document.createRange();
  //     range.selectNodeContents(textRef.current);
  //     range.collapse(false); // collapse at end
  //   }

  //   selection.removeAllRanges();
  //   selection.addRange(range);

  //   const img = document.createElement("img");
  //   img.src = url;
  //   img.alt = "img";
  //   img.style.display = "inline-block";
  //   img.style.maxHeight = "150px";
  //   img.style.verticalAlign = "middle";
  //   img.contentEditable = "false";

  //   const wraper = wrapWithResizer(img);

  //   range.insertNode(wraper);

  //   // Move cursor after image
  //   range.setStartAfter(wraper);
  //   range.collapse(true);
  //   selection.removeAllRanges();
  //   selection.addRange(range);

  //   lastRangeRef.current = range;
  //   // saveTextarea();
  // };

  // for dragging database columns :
  const handleDragOver = (e) => {
    e.preventDefault();
    // setActiveField(index);      // 🆕 Track which field is active
    setShowCursor(true);

    const rect = textRef.current.getBoundingClientRect();
    setCursorPosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  const handleDragLeave = () => setShowCursor(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setShowCursor(false);
    setIsDragging(false);

    const text = e.dataTransfer.getData("text/plain");
    const field = textRef.current;

    const range = document.caretRangeFromPoint(e.clientX, e.clientY);
    if (range) {
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);

      const node = document.createTextNode(text + " ");
      range.insertNode(node);

      range.setStartAfter(node);
      range.setEndAfter(node);
      sel.removeAllRanges();
      sel.addRange(range);
    }

    field.focus();
  };

  // Register both functions
  useEffect(() => {
    registerApplyStyle(() => applyStyleToSelectedText);
    registerSaveHandler(() => saveTextarea);
    registerInsertImage(() => insertImageAtCursor);
    registerGetStyles(() => getAppliedStyles);
  }, [
    registerApplyStyle,
    registerSaveHandler,
    registerInsertImage,
    registerGetStyles,
  ]);

  // Add scroll listener to remove handles
  useEffect(() => {
    const handleScroll = () => {
      if (currentImageRef.current) {
        removeResizeHandles();
        currentImageRef.current = null;
      }
    };

    if (textRef.current) {
      textRef.current.addEventListener("scroll", handleScroll);
      return () => textRef.current?.removeEventListener("scroll", handleScroll);
    }
  }, []);

  return (
    <div style={{ width: "100%" }}>
      {/* Image Action Tooltip */}
      {/* {selectedImage && (
            <div
              className="absolute top-3 left-3 z-50 flex items-center"
              style={{ top: tooltipPos.top, left: tooltipPos.left }}
            >
              
              <button
                onClick={() => {
                  selectedImage.remove();
                  setSelectedImage(null);
                }}
                className="w-8 h-8 flex items-center justify-center 
                  rounded-full border border-red-400 text-red-500 
                  hover:bg-red-500 hover:text-white transition
                ">
                <Trash2 size={16} />
              </button>

            
              <button
                onClick={() => setShowImageModal(true)}
                className="w-8 h-8 flex items-center justify-center 
                    rounded-full border border-blue-400 text-blue-500 
                    hover:bg-blue-500 hover:text-white transition
                  ">
                <Replace size={16} />
              </button>
            </div>
          )} */}
      <div
        ref={textRef}
        onClick={(e) => {
          setEditDiv(true);
          handleImageClick(e);
        }}
        contentEditable={editDiv}
        suppressContentEditableWarning={true}
        // DO NOT SAVE ON EVERY INPUT
        onInput={saveSelection}
        onBlur={() => {
          saveSelection();
          saveTextarea();
        }}
        onKeyUp={() => {
          saveSelection();
          saveSelectionforAcnchor();
        }}
        onMouseUp={() => {
          saveSelection();
          saveSelectionforAcnchor();
          handleMouseUp();
        }}
        style={style}
        onMouseMove={handleMouseMove}
        onDragOver={(e) => handleDragOver(e)}
        onDragLeave={handleDragLeave}
        onDrop={(e) => handleDrop(e)}
        className="editable"
        // Render only once on mount
        dangerouslySetInnerHTML={{ __html: textarea }}
      />
      {/*    
  <div style={{ maxWidth: "900px", margin: "0 auto", padding: "20px" }}>
        <style>{`
              .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
              .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
                  content: '12px';
              }
              .ql-editor .ql-size-12px {
                  font-size: 12px !important;
              }
      
              .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
              .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
                  content: '14px';
              }
              .ql-editor .ql-size-14px {
                  font-size: 14px !important;
              }
      
              .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
              .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
                  content: '16px';
              }
              .ql-editor .ql-size-16px {
                  font-size: 16px !important;
              }
      
              .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
              .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
                  content: '18px';
              }
              .ql-editor .ql-size-18px {
                  font-size: 18px !important;
              }
      
              .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before,
              .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
                  content: '24px';
              }
              .ql-editor .ql-size-24px {
                  font-size: 24px !important;
              }
      
              .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
              .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
                  content: '32px';
              }
              .ql-editor .ql-size-32px {
                  font-size: 32px !important;
              }
      
              .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="48px"]::before,
              .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="48px"]::before {
                  content: '48px';
              }
              .ql-editor .ql-size-48px {
                  font-size: 48px !important;
              }
      
              .ql-snow .ql-picker.ql-size .ql-picker-label:not([data-value])::before,
              .ql-snow .ql-picker.ql-size .ql-picker-item:not([data-value])::before {
                  content: 'Normal';
              }
      
              
              .ql-editor img {
                  cursor: pointer;
                  transition: box-shadow 0.2s;
              }
              .ql-editor img:hover {
                  box-shadow: 0 0 0 2px #1976d2;
              }
              `}</style>
              */}

      {/* <div
          style={{
            border: "1px solid #ddd",
            borderRadius: "8px",
            backgroundColor: "#fff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          }}
        >
          <ReactQuill
            ref={quillRef}
            theme="snow"
            value={textarea}
            onChange={(content, delta, source, editor) => {
              if (source === "user") {
                saveTextarea(content);
              }
            }}
            // onBlur={saveTextarea}
            modules={modules}
            formats={formats}
            placeholder="Start writing..."
            // style={{ minHeight: "400px" }}
          />
        </div>

        
        {showImageModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
              backdropFilter: "blur(4px)",
            }}
            onClick={() => {
              setShowImageModal(false);
              setImageUrl("");
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "32px",
                borderRadius: "12px",
                width: "500px",
                maxWidth: "90%",
                boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h3 style={{ marginTop: 0, marginBottom: "24px", color: "#333" }}>
                {selectedImage ? "Replace Image" : "Insert Image"}
              </h3>

              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#555",
                  }}
                >
                  Image URL
                </label>
                <input
                  type="text"
                  value={imageUrl}
                  onChange={(e) => setImageUrl(e.target.value)}
                  placeholder="https://example.com/image.jpg"
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: "2px solid #e0e0e0",
                    borderRadius: "6px",
                    fontSize: "14px",
                    boxSizing: "border-box",
                    transition: "border-color 0.2s",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#1976d2")}
                  onBlur={(e) => (e.target.style.borderColor = "#e0e0e0")}
                />
              </div>

              <div
                style={{
                  textAlign: "center",
                  margin: "24px 0",
                  position: "relative",
                }}
              >
                <span
                  style={{
                    backgroundColor: "white",
                    padding: "0 12px",
                    color: "#999",
                    position: "relative",
                    zIndex: 1,
                    fontSize: "13px",
                    fontWeight: "500",
                  }}
                >
                  OR
                </span>
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: 0,
                    right: 0,
                    height: "1px",
                    backgroundColor: "#e0e0e0",
                    zIndex: 0,
                  }}
                ></div>
              </div>

              <div style={{ marginBottom: "24px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#555",
                  }}
                >
                  Upload Image
                </label>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  style={{ display: "none" }}
                />
                <button
                  onClick={() => fileInputRef.current.click()}
                  disabled={uploading}
                  style={{
                    width: "100%",
                    padding: "12px",
                    backgroundColor: uploading ? "#e0e0e0" : "#f5f5f5",
                    border: "2px dashed #ccc",
                    borderRadius: "6px",
                    cursor: uploading ? "not-allowed" : "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#666",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    if (!uploading) {
                      e.target.style.borderColor = "#1976d2";
                      e.target.style.backgroundColor = "#e3f2fd";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!uploading) {
                      e.target.style.borderColor = "#ccc";
                      e.target.style.backgroundColor = "#f5f5f5";
                    }
                  }}
                >
                  {uploading ? "⏳ Uploading..." : "Choose File"}
                </button>
                {imageUrl && (
                  <div
                    style={{
                      marginTop: "10px",
                      fontSize: "12px",
                      color: "#4caf50",
                      fontWeight: "500",
                    }}
                  >
                    ✓ Image ready: {imageUrl.substring(0, 50)}...
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "flex-end",
                }}
              >
                <button
                  onClick={() => {
                    setShowImageModal(false);
                    setImageUrl("");
                    if (selectedImage) setSelectedImage(null);
                  }}
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "#f5f5f5",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#666",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#e0e0e0")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "#f5f5f5")
                  }
                >
                  Cancel
                </button>
                <button
                  onClick={insertImage}
                  disabled={!imageUrl.trim()}
                  style={{
                    padding: "10px 20px",
                    backgroundColor: imageUrl.trim() ? "#1976d2" : "#ccc",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    cursor: imageUrl.trim() ? "pointer" : "not-allowed",
                    fontSize: "14px",
                    fontWeight: "500",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    if (imageUrl.trim()) {
                      e.target.style.backgroundColor = "#1565c0";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (imageUrl.trim()) {
                      e.target.style.backgroundColor = "#1976d2";
                    }
                  }}
                >
                  {selectedImage ? "Replace Image" : "Insert Image"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div> */}

      {/* Cursor line */}
      {/* {showCursor && isDragging && (
        <div
          className="absolute pointer-events-none"
          style={{
            left: cursorPosition.x,
            top: cursorPosition.y,
            width: "3px",
            height: "22px",
            backgroundColor: "#6366f1",
            borderRadius: "2px",
          }}
        />
      )} */}
    </div>
  );
}

// import { useRef, useEffect, useContext, useState, useMemo } from "react";
// import { TextEditorContext } from "../../../context/TextEditorContext";
// import { EmailTemplateContext } from "../../../context/EmailTemplateContext";
// import { SelectedElementContex } from "../../../context/SelectedElement";
// import { DatabaseDropdownContext } from "../../../context/DatabaseDropdownContext";
// import { TableRowColumnIndexContex } from "../../../context/TableRowColumnIndexContex";

// import ReactQuill, { Quill } from "react-quill";
// import ImageResize from "quill-image-resize-module-react";
// import "react-quill/dist/quill.snow.css";
// import axios from "axios";
// import { BASE_URL } from "../../../services/configUrls";
// import { Trash2, Replace } from "lucide-react";
// import { ActiveEditorContext } from "../../../context/ActiveEditorContext";

// // ============= PROPER SIZE FORMAT REGISTRATION =============
// const Size = Quill.import("formats/size");
// Size.whitelist = ["12px", "14px", "16px", "18px", "24px", "32px", "48px"];
// Quill.register(Size, true);

// // Register the image resize module
// Quill.register("modules/imageResize", ImageResize);

// // Custom inline image format
// const ImageBlot = Quill.import("formats/image");
// class InlineImageBlot extends ImageBlot {
//   static create(value) {
//     const node = super.create(value);
//     node.setAttribute(
//       "style",
//       "display: inline-block; vertical-align: middle; max-width: 100%;"
//     );
//     return node;
//   }
// }
// InlineImageBlot.blotName = "image";
// InlineImageBlot.tagName = "IMG";
// Quill.register(InlineImageBlot, true);

// export default function TextComponent({ id, style, textarea }) {
//   const { selectedElement, setSelectedElement } = useContext(SelectedElementContex);
//   const { registerSaveHandler } = useContext(TextEditorContext);
//   const { setEmailTemplate } = useContext(EmailTemplateContext);

//   const [selectedImage, setSelectedImage] = useState(null);
//   const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });
//   const [showImageModal, setShowImageModal] = useState(false);
//   const [imageUrl, setImageUrl] = useState("");
//   const [uploading, setUploading] = useState(false);
//   const [viewQuilEditer, setViewQuilEditer] = useState(false);

//   const { activeEditor, setActiveEditor } = useContext(ActiveEditorContext);

//   const quillRef = useRef(null);
//   const fileInputRef = useRef(null);
//   const toolbarRef = useRef(null);

//   // Handle image upload to FastAPI
//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setUploading(true);
//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       const res = await axios.post(
//         `${BASE_URL}/schedule_email/upload-image`,
//         formData,
//         {
//           headers: { "Content-Type": "multipart/form-data" },
//         }
//       );

//       const url = res.data.image_url;
//       setImageUrl(url);
//       setUploading(false);
//     } catch (error) {
//       console.error("Upload failed:", error);
//       alert("Image upload failed");
//       setUploading(false);
//     }
//   };

//   const insertImage = () => {
//     if (!imageUrl.trim()) {
//       alert("Please enter an image URL or upload an image");
//       return;
//     }

//     const quill = quillRef.current.getEditor();
//     quill.focus();

//     setTimeout(() => {
//       if (selectedImage) {
//         const imgBlot = quill.constructor.find(selectedImage);
//         if (imgBlot) {
//           const imageIndex = quill.getIndex(imgBlot);
//           quill.deleteText(imageIndex, 1);
//           quill.insertEmbed(imageIndex, "image", imageUrl, "user");
//           quill.setSelection(imageIndex + 1);
//         }
//         setSelectedImage(null);
//       } else {
//         const range = quill.getSelection(true) || {
//           index: quill.getLength() > 0 ? quill.getLength() - 1 : 0,
//         };
//         quill.insertEmbed(range.index, "image", imageUrl, "user");
//         quill.setSelection(range.index + 1);
//       }

//       saveTextarea(quill.root.innerHTML);
//     }, 50);

//     setImageUrl("");
//     setShowImageModal(false);
//   };

//   const imageHandler = () => {
//     setShowImageModal(true);
//   };

//   const modules = useMemo(
//     () => ({
//       toolbar: {
//         container: "#global-toolbar",
//         handlers: {
//           image: imageHandler,
//         },
//       },
//       imageResize: {
//         parchment: Quill.import("parchment"),
//         modules: ["Resize", "DisplaySize"],
//       },
//     }),
//     []
//   );

//   const formats = [
//     "header",
//     "size",
//     "bold",
//     "italic",
//     "underline",
//     "strike",
//     "color",
//     "background",
//     "align",
//     "list",
//     "bullet",
//     "link",
//     "image",
//     "width",
//     "height",
//   ];

//   // Register this editor as active when focused
//   useEffect(() => {
//     const quill = quillRef.current?.getEditor();
//     if (!quill) return;

//     const handleFocus = () => {
//       setActiveEditor({ id, quillRef, saveTextarea });
//     };

//     quill.on('selection-change', (range) => {
//       if (range) {
//         setActiveEditor({ id, quillRef, saveTextarea });
//       }
//     });

//     const editorElement = quill.root;
//     editorElement.addEventListener('focus', handleFocus);

//     return () => {
//       editorElement.removeEventListener('focus', handleFocus);
//     };
//   }, [id]);

//   // Show active border
//   const isActive = activeEditor?.id === id;
//   // Handle image clicks for delete/replace functionality
//   useEffect(() => {
//     const handleImageClick = (e) => {
//       if (e.target.tagName === "IMG") {
//         setSelectedImage(e.target);
//         const rect = e.target.getBoundingClientRect();
//         setTooltipPos({
//           top: rect.bottom + window.scrollY + 5,
//           left: rect.left + window.scrollX,
//         });
//       } else {
//         setSelectedImage(null);
//       }
//     };

//     const editor = document.querySelector(".ql-editor");
//     if (editor) {
//       editor.addEventListener("click", handleImageClick);
//     }

//     return () => {
//       if (editor) {
//         editor.removeEventListener("click", handleImageClick);
//       }
//     };
//   }, []);

//   // Handle toolbar clicks to maintain editor focus AND selection
// useEffect(() => {
//   const toolbar = document.querySelector("#global-toolbar");

//   if (toolbar && quillRef.current) {
//     let savedSelection = null;

//     const handleToolbarMouseDown = (e) => {
//       const quill = quillRef.current.getEditor();
//       if (!quill) return;

//       // Check if user clicked a toolbar button or picker
//       const isToolbarElement =
//         e.target.closest('button') ||
//         e.target.closest('.ql-picker') ||
//         e.target.classList.contains('ql-picker-label') ||
//         e.target.classList.contains('ql-picker-item');

//       if (isToolbarElement) {
//         // Save the current selection BEFORE the toolbar click
//         savedSelection = quill.getSelection();

//         // Prevent default to avoid losing focus/selection
//         e.preventDefault();

//         // If no selection exists, create one at the end
//         if (!savedSelection) {
//           const length = quill.getLength();
//           savedSelection = { index: length > 0 ? length - 1 : 0, length: 0 };
//           quill.setSelection(savedSelection);
//         }
//       }
//     };

//     const handleToolbarClick = (e) => {
//       const quill = quillRef.current.getEditor();
//       if (!quill) return;

//       const isToolbarElement =
//         e.target.closest('button') ||
//         e.target.closest('.ql-picker') ||
//         e.target.classList.contains('ql-picker-label') ||
//         e.target.classList.contains('ql-picker-item');

//       if (isToolbarElement && savedSelection) {
//         // Restore the saved selection after toolbar action
//         setTimeout(() => {
//           quill.setSelection(savedSelection);
//           quill.focus();
//         }, 0);
//       }
//     };

//     // Use mousedown to capture and save selection before it's lost
//     toolbar.addEventListener('mousedown', handleToolbarMouseDown);
//     // Use click to restore selection after toolbar action
//     toolbar.addEventListener('click', handleToolbarClick);

//     return () => {
//       toolbar.removeEventListener('mousedown', handleToolbarMouseDown);
//       toolbar.removeEventListener('click', handleToolbarClick);
//     };
//   }
// }, []);

//   const onHandleInputChange1 = (f_name, value) => {
//     const updatedData = { ...selectedElement };
//     updatedData.layout[selectedElement.index][f_name] = value;
//     setSelectedElement(updatedData);
//   };

//   const saveTextarea = (newValue) => {
//     onHandleInputChange1("textarea", newValue);
//   };

//   useEffect(() => {
//     registerSaveHandler(() => saveTextarea);
//   }, []);

//   return (
//     <div style={{ width: "100%" }}>
//       {/* Image Action Tooltip - shown inside editor area */}
//       {selectedImage && (
//         <div
//           className="absolute z-50 flex items-center gap-2"
//           style={{ top: tooltipPos.top, left: tooltipPos.left }}
//         >
//           {/* Delete Button */}
//           <button
//             onClick={() => {
//               selectedImage.remove();
//               setSelectedImage(null);
//               const quill = quillRef.current.getEditor();
//               saveTextarea(quill.root.innerHTML);
//             }}
//             className="w-8 h-8 flex items-center justify-center
//               rounded-full border border-red-400 text-red-500
//               hover:bg-red-500 hover:text-white transition"
//           >
//             <Trash2 size={16} />
//           </button>

//           {/* Replace Button */}
//           <button
//             onClick={() => setShowImageModal(true)}
//             className="w-8 h-8 flex items-center justify-center
//               rounded-full border border-blue-400 text-blue-500
//               hover:bg-blue-500 hover:text-white transition"
//           >
//             <Replace size={16} />
//           </button>
//         </div>
//       )}

//       <div style={{ maxWidth: "900px", margin: "0 auto" }}>
//         <style>{`
//           .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
//               content: '12px';
//           }
//           .ql-editor .ql-size-12px {
//               font-size: 12px !important;
//           }

//           .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
//               content: '14px';
//           }
//           .ql-editor .ql-size-14px {
//               font-size: 14px !important;
//           }

//           .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
//               content: '16px';
//           }
//           .ql-editor .ql-size-16px {
//               font-size: 16px !important;
//           }

//           .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
//               content: '18px';
//           }
//           .ql-editor .ql-size-18px {
//               font-size: 18px !important;
//           }

//           .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
//               content: '24px';
//           }
//           .ql-editor .ql-size-24px {
//               font-size: 24px !important;
//           }

//           .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
//               content: '32px';
//           }
//           .ql-editor .ql-size-32px {
//               font-size: 32px !important;
//           }

//           .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="48px"]::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="48px"]::before {
//               content: '48px';
//           }
//           .ql-editor .ql-size-48px {
//               font-size: 48px !important;
//           }

//           .ql-snow .ql-picker.ql-size .ql-picker-label:not([data-value])::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item:not([data-value])::before {
//               content: 'Normal';
//           }

//           /* Image selection highlight */
//           .ql-editor img {
//               cursor: pointer;
//               transition: box-shadow 0.2s;
//           }
//           .ql-editor img:hover {
//               box-shadow: 0 0 0 2px #1976d2;
//           }

//           /* Hide default toolbar */
//           .hide-toolbar .ql-toolbar {
//               display: none;
//           }
//         `}</style>

//         {/* <div
//           className="hide-toolbar"
//           style={{
//             border: "1px solid #ddd",
//             borderRadius: "8px",
//             backgroundColor: "#fff",
//             boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//           }}
//         >
//           <ReactQuill
//             ref={quillRef}
//             theme="snow"
//             value={textarea}
//             onChange={(content, delta, source, editor) => {
//               if (source === "user") {
//                 saveTextarea(content);
//               }
//             }}
//             modules={modules}
//             formats={formats}
//             placeholder="Start writing..."
//           />
//         </div> */}
//         {viewQuilEditer ? (
//           <div
//         className="hide-toolbar"
//         style={{
//           border: isActive ? "2px solid #1976d2" : "1px solid #ddd",
//           borderRadius: "8px",
//           backgroundColor: "#fff",
//           boxShadow: isActive ? "0 0 8px rgba(25, 118, 210, 0.3)" : "0 1px 3px rgba(0,0,0,0.1)",
//           transition: "all 0.2s ease",
//         }}
//       >
//         <ReactQuill
//           ref={quillRef}
//           theme="snow"
//           value={textarea}
//           onChange={(content, delta, source, editor) => {
//             if (source === "user") {
//               saveTextarea(content);
//             }
//           }}
//           onBlur={()=>setViewQuilEditer(false)}
//           modules={modules}
//           formats={formats}
//           placeholder="Start writing..."
//         />
//       </div> ) : (
//         <div
//           onClick={() => setViewQuilEditer(true)}
//           dangerouslySetInnerHTML={{ __html: textarea }}
//           />

//         )}

//         {/* Image Upload Modal */}
//         {showImageModal && (
//           <div
//             style={{
//               position: "fixed",
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               backgroundColor: "rgba(0,0,0,0.6)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               zIndex: 1000,
//               backdropFilter: "blur(4px)",
//             }}
//             onClick={() => {
//               setShowImageModal(false);
//               setImageUrl("");
//             }}
//           >
//             <div
//               style={{
//                 backgroundColor: "white",
//                 padding: "32px",
//                 borderRadius: "12px",
//                 width: "500px",
//                 maxWidth: "90%",
//                 boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
//               }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <h3 style={{ marginTop: 0, marginBottom: "24px", color: "#333" }}>
//                 {selectedImage ? "Replace Image" : "Insert Image"}
//               </h3>

//               <div style={{ marginBottom: "20px" }}>
//                 <label
//                   style={{
//                     display: "block",
//                     marginBottom: "8px",
//                     fontWeight: "600",
//                     fontSize: "14px",
//                     color: "#555",
//                   }}
//                 >
//                   Image URL
//                 </label>
//                 <input
//                   type="text"
//                   value={imageUrl}
//                   onChange={(e) => setImageUrl(e.target.value)}
//                   placeholder="https://example.com/image.jpg"
//                   style={{
//                     width: "100%",
//                     padding: "12px",
//                     border: "2px solid #e0e0e0",
//                     borderRadius: "6px",
//                     fontSize: "14px",
//                     boxSizing: "border-box",
//                     transition: "border-color 0.2s",
//                   }}
//                   onFocus={(e) => (e.target.style.borderColor = "#1976d2")}
//                   onBlur={(e) => (e.target.style.borderColor = "#e0e0e0")}
//                 />
//               </div>

//               <div
//                 style={{
//                   textAlign: "center",
//                   margin: "24px 0",
//                   position: "relative",
//                 }}
//               >
//                 <span
//                   style={{
//                     backgroundColor: "white",
//                     padding: "0 12px",
//                     color: "#999",
//                     position: "relative",
//                     zIndex: 1,
//                     fontSize: "13px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   OR
//                 </span>
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: "50%",
//                     left: 0,
//                     right: 0,
//                     height: "1px",
//                     backgroundColor: "#e0e0e0",
//                     zIndex: 0,
//                   }}
//                 ></div>
//               </div>

//               <div style={{ marginBottom: "24px" }}>
//                 <label
//                   style={{
//                     display: "block",
//                     marginBottom: "8px",
//                     fontWeight: "600",
//                     fontSize: "14px",
//                     color: "#555",
//                   }}
//                 >
//                   Upload Image
//                 </label>
//                 <input
//                   ref={fileInputRef}
//                   type="file"
//                   accept="image/*"
//                   onChange={handleImageUpload}
//                   style={{ display: "none" }}
//                 />
//                 <button
//                   onClick={() => fileInputRef.current.click()}
//                   disabled={uploading}
//                   style={{
//                     width: "100%",
//                     padding: "12px",
//                     backgroundColor: uploading ? "#e0e0e0" : "#f5f5f5",
//                     border: "2px dashed #ccc",
//                     borderRadius: "6px",
//                     cursor: uploading ? "not-allowed" : "pointer",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#666",
//                     transition: "all 0.2s",
//                   }}
//                   onMouseEnter={(e) => {
//                     if (!uploading) {
//                       e.target.style.borderColor = "#1976d2";
//                       e.target.style.backgroundColor = "#e3f2fd";
//                     }
//                   }}
//                   onMouseLeave={(e) => {
//                     if (!uploading) {
//                       e.target.style.borderColor = "#ccc";
//                       e.target.style.backgroundColor = "#f5f5f5";
//                     }
//                   }}
//                 >
//                   {uploading ? "⏳ Uploading..." : "Choose File"}
//                 </button>
//                 {imageUrl && (
//                   <div
//                     style={{
//                       marginTop: "10px",
//                       fontSize: "12px",
//                       color: "#4caf50",
//                       fontWeight: "500",
//                     }}
//                   >
//                     ✓ Image ready: {imageUrl.substring(0, 50)}...
//                   </div>
//                 )}
//               </div>

//               <div
//                 style={{
//                   display: "flex",
//                   gap: "12px",
//                   justifyContent: "flex-end",
//                 }}
//               >
//                 <button
//                   onClick={() => {
//                     setShowImageModal(false);
//                     setImageUrl("");
//                     if (selectedImage) setSelectedImage(null);
//                   }}
//                   style={{
//                     padding: "10px 20px",
//                     backgroundColor: "#f5f5f5",
//                     border: "none",
//                     borderRadius: "6px",
//                     cursor: "pointer",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#666",
//                     transition: "all 0.2s",
//                   }}
//                   onMouseEnter={(e) =>
//                     (e.target.style.backgroundColor = "#e0e0e0")
//                   }
//                   onMouseLeave={(e) =>
//                     (e.target.style.backgroundColor = "#f5f5f5")
//                   }
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={insertImage}
//                   disabled={!imageUrl.trim()}
//                   style={{
//                     padding: "10px 20px",
//                     backgroundColor: imageUrl.trim() ? "#1976d2" : "#ccc",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "6px",
//                     cursor: imageUrl.trim() ? "pointer" : "not-allowed",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     transition: "all 0.2s",
//                   }}
//                   onMouseEnter={(e) => {
//                     if (imageUrl.trim()) {
//                       e.target.style.backgroundColor = "#1565c0";
//                     }
//                   }}
//                   onMouseLeave={(e) => {
//                     if (imageUrl.trim()) {
//                       e.target.style.backgroundColor = "#1976d2";
//                     }
//                   }}
//                 >
//                   {selectedImage ? "Replace Image" : "Insert Image"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// import { useRef, useEffect, useContext, useState, useMemo } from "react";
// import { TextEditorContext } from "../../../context/TextEditorContext";
// import { EmailTemplateContext } from "../../../context/EmailTemplateContext";
// import { SelectedElementContex } from "../../../context/SelectedElement";
// import { ActiveEditorContext } from "../../../context/ActiveEditorContext";

// import ReactQuill, { Quill } from "react-quill";
// import ImageResize from "quill-image-resize-module-react";
// import "react-quill/dist/quill.snow.css";
// import axios from "axios";
// import { BASE_URL } from "../../../services/configUrls";
// import { Trash2, Replace } from "lucide-react";

// // ============= PROPER SIZE FORMAT REGISTRATION =============
// const Size = Quill.import("formats/size");
// Size.whitelist = ["12px", "14px", "16px", "18px", "24px", "32px", "48px"];
// Quill.register(Size, true);

// // Register the image resize module
// Quill.register("modules/imageResize", ImageResize);

// // Custom inline image format
// const ImageBlot = Quill.import("formats/image");
// class InlineImageBlot extends ImageBlot {
//   static create(value) {
//     const node = super.create(value);
//     node.setAttribute(
//       "style",
//       "display: inline-block; vertical-align: middle; max-width: 100%;"
//     );
//     return node;
//   }
// }
// InlineImageBlot.blotName = "image";
// InlineImageBlot.tagName = "IMG";
// Quill.register(InlineImageBlot, true);

// export default function TextComponent({ id, style, textarea }) {
//   const { selectedElement, setSelectedElement } = useContext(SelectedElementContex);
//   const { registerSaveHandler } = useContext(TextEditorContext);
//   const { emailTemplate, setEmailTemplate } = useContext(EmailTemplateContext);
//   const { activeEditor, setActiveEditor } = useContext(ActiveEditorContext);

//   const [selectedImage, setSelectedImage] = useState(null);
//   const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });
//   const [showImageModal, setShowImageModal] = useState(false);
//   const [imageUrl, setImageUrl] = useState("");
//   const [uploading, setUploading] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [toolbarReady, setToolbarReady] = useState(false); // 🆕 Track toolbar readiness

//   const quillRef = useRef(null);
//   const fileInputRef = useRef(null);
//   const updateTimeoutRef = useRef(null);

//   // 🆕 Check if toolbar exists when entering edit mode
//   useEffect(() => {
//     if (isEditing) {
//       const checkToolbar = () => {
//         const toolbar = document.querySelector("#global-toolbar");
//         if (toolbar) {
//           setToolbarReady(true);
//         } else {
//           // Retry after a short delay if toolbar not found
//           setTimeout(checkToolbar, 50);
//         }
//       };
//       checkToolbar();
//     } else {
//       setToolbarReady(false);
//     }
//   }, [isEditing]);

//   const onHandleInputChange1 = (f_name, value) => {
//     //  Copy current selectedElement
//     const updatedData = { ...selectedElement };
//     // Updated the specific field
//     updatedData.layout[selectedElement.index][f_name] = value;
//     // Update original selectedElement
//     setSelectedElement(updatedData);
//   };

//   // Handle image upload to FastAPI
//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setUploading(true);
//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       const res = await axios.post(
//         `${BASE_URL}/schedule_email/upload-image`,
//         formData,
//         {
//           headers: { "Content-Type": "multipart/form-data" },
//         }
//       );

//       const url = res.data.image_url;
//       setImageUrl(url);
//       setUploading(false);
//     } catch (error) {
//       console.error("Upload failed:", error);
//       alert("Image upload failed");
//       setUploading(false);
//     }
//   };

//   const insertImage = () => {
//     if (!imageUrl.trim()) {
//       alert("Please enter an image URL or upload an image");
//       return;
//     }

//     const quill = quillRef.current?.getEditor();
//     if (!quill) return;

//     quill.focus();

//     setTimeout(() => {
//       if (selectedImage) {
//         const imgBlot = quill.constructor.find(selectedImage);
//         if (imgBlot) {
//           const imageIndex = quill.getIndex(imgBlot);
//           quill.deleteText(imageIndex, 1);
//           quill.insertEmbed(imageIndex, "image", imageUrl, "user");
//           quill.setSelection(imageIndex + 1);
//         }
//         setSelectedImage(null);
//       } else {
//         const range = quill.getSelection(true) || {
//           index: quill.getLength() > 0 ? quill.getLength() - 1 : 0,
//         };
//         quill.insertEmbed(range.index, "image", imageUrl, "user");
//         quill.setSelection(range.index + 1);
//       }

//       saveTextarea(quill.root.innerHTML);
//     }, 50);

//     setImageUrl("");
//     setShowImageModal(false);
//   };

//   const imageHandler = () => {
//     setShowImageModal(true);
//   };

//   const modules = useMemo(
//     () => ({
//       toolbar: {
//         container: "#global-toolbar",
//         handlers: {
//           image: imageHandler,
//         },
//       },
//       imageResize: {
//         parchment: Quill.import("parchment"),
//         modules: ["Resize", "DisplaySize"],
//       },
//     }),
//     []
//   );

//   const formats = [
//     "header",
//     "size",
//     "bold",
//     "italic",
//     "underline",
//     "strike",
//     "color",
//     "background",
//     "align",
//     "list",
//     "bullet",
//     "link",
//     "image",
//     "width",
//     "height",
//   ];

//   // Register this editor as active when focused
//   useEffect(() => {
//     if (!toolbarReady) return; // Wait for toolbar

//     const quill = quillRef.current?.getEditor();
//     if (!quill) return;

//     const handleFocus = () => {
//       setActiveEditor({ id, quillRef, saveTextarea });
//     };

//     // Auto-focus when editor becomes ready
//     setTimeout(() => {
//       quill.focus();
//     }, 100);

//     quill.on("selection-change", (range) => {
//       if (range) {
//         setActiveEditor({ id, quillRef, saveTextarea });
//       }
//     });

//     const editorElement = quill.root;
//     editorElement.addEventListener("focus", handleFocus);

//     return () => {
//       editorElement.removeEventListener("focus", handleFocus);
//     };
//   }, [id, toolbarReady]);

//   // Handle image clicks for delete/replace functionality
//   useEffect(() => {
//     if (!toolbarReady) return;

//     const handleImageClick = (e) => {
//       if (e.target.tagName === "IMG") {
//         setSelectedImage(e.target);
//         const rect = e.target.getBoundingClientRect();
//         setTooltipPos({
//           top: rect.bottom + window.scrollY + 5,
//           left: rect.left + window.scrollX,
//         });
//       } else {
//         setSelectedImage(null);
//       }
//     };

//     const editorContainer = quillRef.current?.getEditor()?.root;
//     if (editorContainer) {
//       editorContainer.addEventListener("click", handleImageClick);
//       return () => {
//         editorContainer.removeEventListener("click", handleImageClick);
//       };
//     }
//   }, [toolbarReady]);

//   // Handle toolbar clicks to maintain editor focus AND selection
//   useEffect(() => {
//     if (!toolbarReady) return;

//     const toolbar = document.querySelector("#global-toolbar");

//     if (toolbar && quillRef.current) {
//       let savedSelection = null;

//       const handleToolbarMouseDown = (e) => {
//         const quill = quillRef.current?.getEditor();
//         if (!quill) return;

//         const isToolbarElement =
//           e.target.closest("button") ||
//           e.target.closest(".ql-picker") ||
//           e.target.classList.contains("ql-picker-label") ||
//           e.target.classList.contains("ql-picker-item");

//         if (isToolbarElement) {
//           savedSelection = quill.getSelection();
//           e.preventDefault();

//           if (!savedSelection) {
//             const length = quill.getLength();
//             savedSelection = { index: length > 0 ? length - 1 : 0, length: 0 };
//             quill.setSelection(savedSelection);
//           }
//         }
//       };

//       const handleToolbarClick = (e) => {
//         const quill = quillRef.current?.getEditor();
//         if (!quill) return;

//         const isToolbarElement =
//           e.target.closest("button") ||
//           e.target.closest(".ql-picker") ||
//           e.target.classList.contains("ql-picker-label") ||
//           e.target.classList.contains("ql-picker-item");

//         if (isToolbarElement && savedSelection) {
//           setTimeout(() => {
//             quill.setSelection(savedSelection);
//             quill.focus();
//           }, 0);
//         }
//       };

//       toolbar.addEventListener("mousedown", handleToolbarMouseDown);
//       toolbar.addEventListener("click", handleToolbarClick);

//       return () => {
//         toolbar.removeEventListener("mousedown", handleToolbarMouseDown);
//         toolbar.removeEventListener("click", handleToolbarClick);
//       };
//     }
//   }, [toolbarReady]);

//   // Debounced update to prevent rapid selectedElement changes
//   const saveTextarea = (newValue) => {
//     if (!selectedElement) return;

//     // Clear previous timeout
//     if (updateTimeoutRef.current) {
//       clearTimeout(updateTimeoutRef.current);
//     }

//     // // Update emailTemplate immediately (no lag for user)
//     // setEmailTemplate((prevTemplate) =>
//     //   prevTemplate.map((item) => {
//     //     if (item.id === selectedElement.layout.id) {
//     //       const updatedLayout = { ...item };
//     //       updatedLayout[selectedElement.index] = {
//     //         ...updatedLayout[selectedElement.index],
//     //         textarea: newValue,
//     //       };
//     //       return updatedLayout;
//     //     }
//     //     return item;
//     //   })
//     // );

//     // // Debounce selectedElement update (prevents loop during fast typing)
//     // updateTimeoutRef.current = setTimeout(() => {
//     //   const updatedSelectedElement = { ...selectedElement };
//     //   updatedSelectedElement.layout[selectedElement.index].textarea = newValue;
//     //   setSelectedElement(updatedSelectedElement);
//     // }, 300);
//     onHandleInputChange1("textarea", newValue);
//   };

//   useEffect(() => {
//     registerSaveHandler(() => saveTextarea);

//     // return () => {
//     //   if (updateTimeoutRef.current) {
//     //     clearTimeout(updateTimeoutRef.current);
//     //   }
//     // };
//   }, []);

//   const isActive = activeEditor?.id === id;
//   const safeTextarea = textarea || "";

//   return (
//     <div style={{ width: "100%", position: "relative" }}>
//       {/* Image Action Tooltip */}
//       {selectedImage && toolbarReady && (
//         <div
//           className="absolute z-50 flex items-center gap-2"
//           style={{ top: tooltipPos.top, left: tooltipPos.left }}
//         >
//           <button
//             onClick={() => {
//               selectedImage.remove();
//               setSelectedImage(null);
//               const quill = quillRef.current?.getEditor();
//               if (quill) saveTextarea(quill.root.innerHTML);
//             }}
//             className="w-8 h-8 flex items-center justify-center
//               rounded-full border border-red-400 text-red-500
//               hover:bg-red-500 hover:text-white transition"
//           >
//             <Trash2 size={16} />
//           </button>

//           <button
//             onClick={() => setShowImageModal(true)}
//             className="w-8 h-8 flex items-center justify-center
//               rounded-full border border-blue-400 text-blue-500
//               hover:bg-blue-500 hover:text-white transition"
//           >
//             <Replace size={16} />
//           </button>
//         </div>
//       )}

//       <div style={{ maxWidth: "900px", margin: "0 auto" }}>
//         <style>{`
//           .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
//               content: '12px';
//           }
//           .ql-editor .ql-size-12px {
//               font-size: 12px !important;
//           }

//           .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
//               content: '14px';
//           }
//           .ql-editor .ql-size-14px {
//               font-size: 14px !important;
//           }

//           .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
//               content: '16px';
//           }
//           .ql-editor .ql-size-16px {
//               font-size: 16px !important;
//           }

//           .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
//               content: '18px';
//           }
//           .ql-editor .ql-size-18px {
//               font-size: 18px !important;
//           }

//           .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
//               content: '24px';
//           }
//           .ql-editor .ql-size-24px {
//               font-size: 24px !important;
//           }

//           .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
//               content: '32px';
//           }
//           .ql-editor .ql-size-32px {
//               font-size: 32px !important;
//           }

//           .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="48px"]::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="48px"]::before {
//               content: '48px';
//           }
//           .ql-editor .ql-size-48px {
//               font-size: 48px !important;
//           }

//           .ql-snow .ql-picker.ql-size .ql-picker-label:not([data-value])::before,
//           .ql-snow .ql-picker.ql-size .ql-picker-item:not([data-value])::before {
//               content: 'Normal';
//           }

//           .ql-editor img {
//               cursor: pointer;
//               transition: box-shadow 0.2s;
//           }
//           .ql-editor img:hover {
//               box-shadow: 0 0 0 2px #1976d2;
//           }

//           .hide-toolbar .ql-toolbar {
//               display: none;
//           }

//           .text-preview {
//               min-height: 40px;
//               padding: 12px;
//               border: 1px solid #ddd;
//               border-radius: 8px;
//               cursor: text;
//               background: #ffffff;
//               transition: all 0.2s ease;
//           }
//           .text-preview:hover {
//               border-color: #1976d2;
//           }
//           .text-preview p {
//               margin: 0;
//           }
//           .text-preview:empty:before {
//               content: 'Click to edit...';
//               color: #999;
//           }
//         `}</style>

//         {/* 🔧 Only render ReactQuill when toolbar is ready */}
//         {isEditing && toolbarReady ? (
//           <div
//             className="hide-toolbar"
//             style={{
//               border: isActive ? "2px solid #1976d2" : "1px solid #ddd",
//               borderRadius: "8px",
//               backgroundColor: "#ffffff",
//               boxShadow: isActive
//                 ? "0 0 8px rgba(25, 118, 210, 0.3)"
//                 : "0 1px 3px rgba(0,0,0,0.1)",
//               transition: "all 0.2s ease",
//             }}
//           >
//             <ReactQuill
//               ref={quillRef}
//               theme="snow"
//               value={safeTextarea}
//               onChange={(content, delta, source, editor) => {
//                 if (source === "user") {
//                   saveTextarea(content);
//                 }
//               }}
//               onBlur={() => {
//                 setTimeout(() => setIsEditing(false), 200);
//               }}
//               modules={modules}
//               formats={formats}
//               placeholder="Start writing..."
//             />
//           </div>
//         ) : (
//           // Clean HTML for export (no Quill wrapper)
//           <div
//             className="text-preview"
//             onClick={() => {
//               setIsEditing(true);
//             }}
//             dangerouslySetInnerHTML={{ __html: safeTextarea }}
//           />
//         )}

//         {/* Image Upload Modal - same as before */}
//         {showImageModal && (
//           <div
//             style={{
//               position: "fixed",
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               backgroundColor: "rgba(0,0,0,0.6)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               zIndex: 1000,
//               backdropFilter: "blur(4px)",
//             }}
//             onClick={() => {
//               setShowImageModal(false);
//               setImageUrl("");
//             }}
//           >
//             <div
//               style={{
//                 backgroundColor: "white",
//                 padding: "32px",
//                 borderRadius: "12px",
//                 width: "500px",
//                 maxWidth: "90%",
//                 boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
//               }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <h3 style={{ marginTop: 0, marginBottom: "24px", color: "#333" }}>
//                 {selectedImage ? "Replace Image" : "Insert Image"}
//               </h3>

//               <div style={{ marginBottom: "20px" }}>
//                 <label
//                   style={{
//                     display: "block",
//                     marginBottom: "8px",
//                     fontWeight: "600",
//                     fontSize: "14px",
//                     color: "#555",
//                   }}
//                 >
//                   Image URL
//                 </label>
//                 <input
//                   type="text"
//                   value={imageUrl}
//                   onChange={(e) => setImageUrl(e.target.value)}
//                   placeholder="https://example.com/image.jpg"
//                   style={{
//                     width: "100%",
//                     padding: "12px",
//                     border: "2px solid #e0e0e0",
//                     borderRadius: "6px",
//                     fontSize: "14px",
//                     boxSizing: "border-box",
//                     transition: "border-color 0.2s",
//                   }}
//                   onFocus={(e) => (e.target.style.borderColor = "#1976d2")}
//                   onBlur={(e) => (e.target.style.borderColor = "#e0e0e0")}
//                 />
//               </div>

//               <div
//                 style={{
//                   textAlign: "center",
//                   margin: "24px 0",
//                   position: "relative",
//                 }}
//               >
//                 <span
//                   style={{
//                     backgroundColor: "white",
//                     padding: "0 12px",
//                     color: "#999",
//                     position: "relative",
//                     zIndex: 1,
//                     fontSize: "13px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   OR
//                 </span>
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: "50%",
//                     left: 0,
//                     right: 0,
//                     height: "1px",
//                     backgroundColor: "#e0e0e0",
//                     zIndex: 0,
//                   }}
//                 ></div>
//               </div>

//               <div style={{ marginBottom: "24px" }}>
//                 <label
//                   style={{
//                     display: "block",
//                     marginBottom: "8px",
//                     fontWeight: "600",
//                     fontSize: "14px",
//                     color: "#555",
//                   }}
//                 >
//                   Upload Image
//                 </label>
//                 <input
//                   ref={fileInputRef}
//                   type="file"
//                   accept="image/*"
//                   onChange={handleImageUpload}
//                   style={{ display: "none" }}
//                 />
//                 <button
//                   onClick={() => fileInputRef.current.click()}
//                   disabled={uploading}
//                   style={{
//                     width: "100%",
//                     padding: "12px",
//                     backgroundColor: uploading ? "#e0e0e0" : "#f5f5f5",
//                     border: "2px dashed #ccc",
//                     borderRadius: "6px",
//                     cursor: uploading ? "not-allowed" : "pointer",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#666",
//                     transition: "all 0.2s",
//                   }}
//                   onMouseEnter={(e) => {
//                     if (!uploading) {
//                       e.target.style.borderColor = "#1976d2";
//                       e.target.style.backgroundColor = "#e3f2fd";
//                     }
//                   }}
//                   onMouseLeave={(e) => {
//                     if (!uploading) {
//                       e.target.style.borderColor = "#ccc";
//                       e.target.style.backgroundColor = "#f5f5f5";
//                     }
//                   }}
//                 >
//                   {uploading ? "⏳ Uploading..." : "Choose File"}
//                 </button>
//                 {imageUrl && (
//                   <div
//                     style={{
//                       marginTop: "10px",
//                       fontSize: "12px",
//                       color: "#4caf50",
//                       fontWeight: "500",
//                     }}
//                   >
//                     ✓ Image ready: {imageUrl.substring(0, 50)}...
//                   </div>
//                 )}
//               </div>

//               <div
//                 style={{
//                   display: "flex",
//                   gap: "12px",
//                   justifyContent: "flex-end",
//                 }}
//               >
//                 <button
//                   onClick={() => {
//                     setShowImageModal(false);
//                     setImageUrl("");
//                     if (selectedImage) setSelectedImage(null);
//                   }}
//                   style={{
//                     padding: "10px 20px",
//                     backgroundColor: "#f5f5f5",
//                     border: "none",
//                     borderRadius: "6px",
//                     cursor: "pointer",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#666",
//                     transition: "all 0.2s",
//                   }}
//                   onMouseEnter={(e) =>
//                     (e.target.style.backgroundColor = "#e0e0e0")
//                   }
//                   onMouseLeave={(e) =>
//                     (e.target.style.backgroundColor = "#f5f5f5")
//                   }
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={insertImage}
//                   disabled={!imageUrl.trim()}
//                   style={{
//                     padding: "10px 20px",
//                     backgroundColor: imageUrl.trim() ? "#1976d2" : "#ccc",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "6px",
//                     cursor: imageUrl.trim() ? "pointer" : "not-allowed",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     transition: "all 0.2s",
//                   }}
//                   onMouseEnter={(e) => {
//                     if (imageUrl.trim()) {
//                       e.target.style.backgroundColor = "#1565c0";
//                     }
//                   }}
//                   onMouseLeave={(e) => {
//                     if (imageUrl.trim()) {
//                       e.target.style.backgroundColor = "#1976d2";
//                     }
//                   }}
//                 >
//                   {selectedImage ? "Replace Image" : "Insert Image"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }
